import cx from 'classnames';
import PT from 'prop-types';
import { Button } from 'edrolo-style-guide';
import styles from './TeacherMarkingSummary.scss';

const TeacherMarkingSummary = ({
  studentCount,
  submissionCount,
  commentCount,
  hasMarkableQuestions,
  markExamUrl,
  examSolutionsUrl,
}) => (
  <div
    className={cx(styles.teacherMarkingSummary)}
    data-test={'teacher-marking-summary'}
  >
    <div>
      <p>
        <b className={cx(styles.heading)}>
          {submissionCount} of your {studentCount} students have submitted this
          exam.
        </b>
      </p>
      <p>{`You've commented on ${commentCount} of their responses.`}</p>

      {examSolutionsUrl ? (
        <a
          href={`${examSolutionsUrl}#preview`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Print exam with solutions
        </a>
      ) : null}
    </div>
    <Button
      // TODO: use anchor tag and style it as a button instead
      small
      onClick={() => (window.location.href = markExamUrl)}
      disabled={!hasMarkableQuestions}
    >
      {hasMarkableQuestions ? 'Mark this exam' : 'No markable questions'}
    </Button>
  </div>
);

TeacherMarkingSummary.propTypes = {
  studentCount: PT.number,
  submissionCount: PT.number,
  commentCount: PT.number,
  hasMarkableQuestions: PT.bool,
  markExamUrl: PT.string,
  examSolutionsUrl: PT.string, // ??
};

export default TeacherMarkingSummary;
